// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"237":"pages","499":"branches","594":"about","651":"courses","962":"home"}[chunkId] || chunkId) + "." + {"237":"2f32dd70","499":"c662004b","594":"3c3e0574","651":"32a42df9","656":"37e298d2","812":"50c70aad","883":"63d8555e","962":"47eeb4aa"}[chunkId] + ".css";
};